import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";

import {renderQuestion} from "../../../../../utils";

const EmployerInformationStep = props => {
  const {
    questions,
    onAnswerChange,
    dataService
  } = props;

  const bankConfig = dataService.getBankConfig();
  const isEmployerInformationMandatory = bankConfig.is_employer_information_mandatory;
  const isEmployerInformationEmployeeIdMandatory = bankConfig.is_employer_information_employee_id_mandatory;

  const handleAnswerChange = (question, answer) => {
    onAnswerChange(question, answer);
    if (!isEmployerInformationMandatory) {
      if (questions.some((q) => !_.isEmpty(q.answer))) {
        questions.forEach((q) => {
          q.optional = q.uid === "employer['employee_id']" && !isEmployerInformationEmployeeIdMandatory
        })
      } else {
        questions.forEach((q) => {
          q.error = null
          q.optional = true
        })
      }
    }
  };

  return (
    <Grid container spacing={2}>
      {questions.map(q => renderQuestion(q, handleAnswerChange, dataService))}
    </Grid>
  );
};

export default EmployerInformationStep;
